import { render } from "./CreateUserForm.vue?vue&type=template&id=c6797700&scoped=true"
import script from "./CreateUserForm.vue?vue&type=script&lang=js"
export * from "./CreateUserForm.vue?vue&type=script&lang=js"

import "./CreateUserForm.vue?vue&type=style&index=0&id=c6797700&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6797700"]])

export default __exports__